import { WorkOrderChangeStatusEnum } from 'gql/graphql';

import { useMemo } from 'react';

export const useGetStatusWarningText = ({
    currentStatus,
    nextStatus,
}: {
    currentStatus: WorkOrderChangeStatusEnum | undefined;
    nextStatus: WorkOrderChangeStatusEnum;
}) =>
    useMemo(() => {
        const changedFromFormation = currentStatus === WorkOrderChangeStatusEnum.OnFormation;
        const changedFromApproving = currentStatus === WorkOrderChangeStatusEnum.Approving;

        const changeToApproving = nextStatus === WorkOrderChangeStatusEnum.Approving;
        const changeToApproved = nextStatus === WorkOrderChangeStatusEnum.Approved;

        if (changedFromFormation && changeToApproving) {
            return (
                <>
                    <div style={{ marginBottom: '16px' }}>
                        После перевода в статус «На согласовании» дальнейшая работа по редактированию Изм. к НЗ будет
                        недоступна.
                    </div>
                    <div>Вы уверены, что хотите изменить статус?</div>
                </>
            );
        }

        if (changedFromApproving && changeToApproved) {
            return (
                <>
                    <div style={{ marginBottom: '16px' }}>
                        После перевода в статус «Согласован» Изм. к НЗ станет текущей версией Наряд-Заказа
                    </div>
                    <div>Вы уверены, что хотите изменить статус?</div>
                </>
            );
        }

        return <div> Вы уверены, что хотите изменить статус?</div>;
    }, [currentStatus, nextStatus]);
